import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { UI } from "@/content/ui";
import { useLang } from "@/lib/lang";

export default function CtaBand({ title, sub }) {
  const { t } = useLang();
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-[1320px] px-5 md:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-electric px-7 py-14 md:px-16 md:py-20">
            <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-white/10 blur-2xl" />
            <div className="pointer-events-none absolute -bottom-24 left-1/3 h-64 w-64 rounded-full bg-turquoise/25 blur-3xl" />
            <div className="relative">
              <p className="text-xs font-bold uppercase tracking-widest2 text-turquoise-bright">{t(UI.cta.talk)} —</p>
              <h2 className="mt-4 max-w-2xl font-display text-4xl font-bold leading-[1.08] text-white md:text-5xl">{title}</h2>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-white/85">{sub}</p>
              <div className="mt-9 flex flex-wrap gap-4">
                <Link
                  to="/contact"
                  data-testid="cta-band-quote-button"
                  className="group inline-flex items-center gap-2 rounded-full bg-white px-7 py-4 text-sm font-bold text-electric-dark transition-all duration-300 hover:bg-ice"
                >
                  {t(UI.cta.quote)}
                  <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
                <Link
                  to="/contact"
                  data-testid="cta-band-consult-button"
                  className="inline-flex items-center gap-2 rounded-full border border-white/40 px-7 py-4 text-sm font-semibold text-white transition-colors duration-300 hover:border-white hover:bg-white/10"
                >
                  {t(UI.cta.consult)}
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
